<mat-form-field [formGroup]="group" class="input" appearance="outline">
    <mat-label>{{ config.label }}</mat-label>
    <input
        #input
        type="text"
        matInput
        [formControlName]="config.name"
        placeholder="+55 (...) ____-____"
        mask="+00 (00) 0000-00000"
        [dropSpecialCharacters]="true" />
    <mat-error
        *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
        Campo obrigatório
    </mat-error>
    <mat-error
        *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('mask')">
        Formato inválido.
    </mat-error>
</mat-form-field>
